import { Box, Button, CircularProgress, Container, Dialog, DialogContent, DialogTitle, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { themePalette } from "../../config/theme.config";
import CategoriasService from "../../services/CategoriasService";
import TipoEventosService from "../../services/TipoEventoService";
import TematicaService from "../../services/TematicaService";
import { CategoriaTable } from "../../componente/Categoria/CategoriaTable";
import { GetVoidResponseApi, ResponseApi } from "../../types/Response/ResponseApi";
import { Categoria, GetVoidCategoria } from "../../types/Categoria/Categoria";
import { BarraBusqueda } from "../../common/Behelit/BarraBusqueda";
import { CenterBox } from "../../common/Behelit/CenterBox";
import { Iconify } from "../../common/iconify";
import { CategoriaForm } from "../../componente/Categoria/CategoriaForm";
import { GetVoidTipoEvento, TipoEvento } from "../../types/TipoEvento/TipoEvento";
import { GetVoidTematica, Tematica } from "../../types/Tematica/Tematica";
import { TipoEventoTable } from "../../componente/TipoEvento/TipoEventoTable";
import { TematicaTable } from "../../componente/Tematica/TematicaTable";
import { TipoEventoForm } from "../../componente/TipoEvento/TipoEventoForm";
import { TematicaForm } from "../../componente/Tematica/TematicaForm";

export const ConfigPage: React.FC<{}> = () => {
    const [loadingC, setLoadingC] = useState(true);
    const [searchCat, setSearchCat] = useState('');
    const [categoriaData, setCategoriaData] = useState<ResponseApi<Categoria>>(GetVoidResponseApi<Categoria>());
    const [categoria, setCategoria] = useState(GetVoidCategoria());
    const [openC, setOpenC] = useState(false);
    const [loadingE, setLoadingE] = useState(true);
    const [searchTE, setSearchTE] = useState('');
    const [tipoEventData, setTipoEventData] = useState<ResponseApi<TipoEvento>>(GetVoidResponseApi<TipoEvento>());
    const [tipoEvent, setTipoEvent] = useState(GetVoidTipoEvento());
    const [openE, setOpenE] = useState(false);
    const [loadingT, setLoadingT] = useState(true);
    const [searchT, setSearchT] = useState('');
    const [tematicaData, setTematicaData] = useState<ResponseApi<Tematica>>(GetVoidResponseApi<Tematica>());
    const [tematica, setTematica] = useState(GetVoidTematica());
    const [openT, setOpenT] = useState(false);
    const [tab, setTab] = useState(0);

    const handleClickOpenC = () => {
        setOpenC(true);
    };

    const handleCloseC = () => {
        setOpenC(false);
    };
    const handleClickOpenE = () => {
        setOpenE(true);
    };

    const handleCloseE = () => {
        setOpenE(false);
    };
    const handleClickOpenT = () => {
        setOpenT(true);
    };

    const handleCloseT = () => {
        setOpenT(false);
    };
    // Function
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
        //console.log(newValue);
    };
    const handleSearchChange = (value: string) => {
        setSearchCat(value);
    };
    const handleSearchTEChange = (value: string) => {
        setSearchTE(value);
    };
    const handleSearchTChange = (value: string) => {
        setSearchT(value);
    };
    const handleResponse = async (responseData: any) => {
        handleCloseC();
        fetchCategorias(1, 10);
    };
    const handleResponse2 = async (responseData: any) => {
        handleCloseE();
        fetchTipoEvento(1, 10);
    };
    const handleResponse3 = async (responseData: any) => {
        handleCloseT();
        fetchTematica(1, 10);
    };
    useEffect(() => {
        if (searchCat.length === 0) {
            fetchCategorias(1, 10);
        }
        if (searchCat.length < 3) return;
        const debounce = setTimeout(() => {
            fetchCategoriasPage(1, 10)
        }, 500)
        function cleanup() {
            clearTimeout(debounce)
        }
    }, [searchCat])

    useEffect(() => {
        if (searchTE.length === 0) {
            fetchTipoEvento(1, 10);
        }
        if (searchTE.length < 3) return;
        const debounce = setTimeout(() => {
            fetchTipoEventoPage(1, 10)
        }, 500)
        function cleanup() {
            clearTimeout(debounce)
        }
    }, [searchTE])

    useEffect(() => {
        if (searchT.length === 0) {
            fetchTematica(1, 10);
        }
        if (searchT.length < 3) return;
        const debounce = setTimeout(() => {
            fetchTematicaPage(1, 10)
        }, 500)
        function cleanup() {
            clearTimeout(debounce)
        }
    }, [searchT])

    const fetchCategorias = async (page: number, pageSize: number) => {
        try {
            const response = await CategoriasService.GetCategorias(page, pageSize);
            const data = response;
            if (data.status.isSuccessfully) {
                setCategoriaData(data);
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoadingC(false);
        }
    }
    const fetchCategoriasPage = async (page: number, pageSize: number) => {
        try {
            const response = await CategoriasService.GetCategoriasByName(searchCat, page, pageSize);
            const data = response;
            if (data.status.isSuccessfully) {
                setCategoriaData(data);
            }
        } catch (error) {
            console.error(error)
        }
    }
    const fetchTipoEvento = async (page: number, pageSize: number) => {
        try {
            const response = await TipoEventosService.GetTipoEventos(page, pageSize);
            const data = response;
            if (data.status.isSuccessfully) {
                setTipoEventData(data);
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoadingE(false);
        }
    }
    const fetchTipoEventoPage = async (page: number, pageSize: number) => {
        try {
            const response = await TipoEventosService.GetTipoEventosByName(searchTE, page, pageSize);
            const data = response;
            if (data.status.isSuccessfully) {
                setTipoEventData(data);
            }
        } catch (error) {
            console.error(error)
        }
    }
    const fetchTematica = async (page: number, pageSize: number) => {
        try {
            const response = await TematicaService.GetTematicas(page,pageSize);
            const data = response;
            if (data.status.isSuccessfully) {
                setTematicaData(data);
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoadingT(false);
        }
    }
    const fetchTematicaPage = async (page: number, pageSize: number) => {
        try {
            const response = await TematicaService.GetTematicasByName(searchT, page, pageSize);
            const data = response;
            if (data.status.isSuccessfully) {
                setTematicaData(data);
            }
        } catch (error) {
            console.error(error)
        }
    }
    // effect
    useEffect(() => {
        fetchCategorias(1, 10);
        fetchTipoEvento(1,10);
        fetchTematica(1,10)
    }, []);

    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center', marginTop: 10, border: `1px solid ${themePalette.NAVCOLOR}`, borderTopWidth: '3px', borderRadius: '5px' }}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                    Configuración
                </Typography>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Tabs
                    value={tab}
                    onChange={handleTabChange}
                    aria-label="Pestañas interactivas"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Categorías" id="tab-0" aria-controls="tabpanel-0" />
                    <Tab label="Tipos de Eventos" id="tab-1" aria-controls="tabpanel-1" />
                    <Tab label="Temáticas" id="tab-2" aria-controls="tabpanel-2" />
                </Tabs>
            </Box>
            {/* Panel de contenido */}
            <Box sx={{ width: '100%', mt: 2 }}>
                <Grid container spacing={1}>
                    {tab === 0 && (<>
                        {loadingC ?
                            <Grid item xs={12}>
                                <CircularProgress />
                            </Grid>
                            : <>
                                <Grid item sm={12} lg={10} >
                                    <BarraBusqueda id={"categoria"} customStyles={{ m: 1, width: '100%' }} input={searchCat} onChange={handleSearchChange} placeholder="Busqueda por nombre..." />
                                </Grid>
                                <Grid item sm={12} lg={2} >
                                    <CenterBox customStyles={{ m: 1, width: '100%' }}>
                                        <Button size="large" variant="contained" color='primary' endIcon={<Iconify icon={"material-symbols:add"} />} onClick={handleClickOpenC}>
                                            Agregar
                                        </Button>
                                    </CenterBox>
                                </Grid>
                                <Grid item sm={12} lg={12} >
                                    <CategoriaTable data={categoriaData} onUpdate={searchCat.length === 0 ? fetchCategorias : fetchCategoriasPage} />
                                </Grid>
                            </>
                        }
                    </>
                    )}
                    {tab === 1 && (
                        <>
                            {loadingE ?
                                <Grid item xs={12}>
                                    <CircularProgress />
                                </Grid>
                                : <>
                                    <Grid item sm={12} lg={10} >
                                        <BarraBusqueda id={"evento"} customStyles={{ m: 1, width: '100%' }} input={searchCat} onChange={handleSearchTEChange} placeholder="Busqueda por nombre..." />
                                    </Grid>
                                    <Grid item sm={12} lg={2} >
                                        <CenterBox customStyles={{ m: 1, width: '100%' }}>
                                            <Button size="large" variant="contained" color='primary' endIcon={<Iconify icon={"material-symbols:add"} />} onClick={handleClickOpenE}>
                                                Agregar
                                            </Button>
                                        </CenterBox>
                                    </Grid>
                                    <Grid item sm={12} lg={12} >
                                        {/* <CategoriaTable data={categoriaData} onUpdate={searchCat.length === 0 ? fetchCategorias : fetchCategoriasPage} /> */}
                                        <TipoEventoTable data={tipoEventData} onUpdate={searchTE.length === 0 ? fetchTipoEvento : fetchTipoEventoPage} />
                                    </Grid>
                                </>
                            }
                        </>
                    )}
                    {tab === 2 && (
                        <>
                            {loadingT ?
                                <Grid item xs={12}>
                                    <CircularProgress />
                                </Grid>
                                : <>
                                    <Grid item sm={12} lg={10} >
                                        <BarraBusqueda id={"tematica"} customStyles={{ m: 1, width: '100%' }} input={searchCat} onChange={handleSearchTChange} placeholder="Busqueda por nombre..." />
                                    </Grid>
                                    <Grid item sm={12} lg={2} >
                                        <CenterBox customStyles={{ m: 1, width: '100%' }}>
                                            <Button size="large" variant="contained" color='primary' endIcon={<Iconify icon={"material-symbols:add"} />} onClick={handleClickOpenT}>
                                                Agregar
                                            </Button>
                                        </CenterBox>
                                    </Grid>
                                    <Grid item sm={12} lg={12} >
                                        <TematicaTable data={tematicaData} onUpdate={searchCat.length === 0 ? fetchTematica : fetchTematicaPage} />
                                    </Grid>
                                </>
                            }
                        </>
                    )}
                </Grid>
            </Box>
            <Dialog
                open={openC}
                onClose={handleCloseC}
            >
                <DialogTitle id="alert-dialog-title">
                    {"Nueva Categoría"}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 1 }} display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                        <CategoriaForm categoria={categoria} onResponse={handleResponse} />
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog
                open={openE}
                onClose={handleCloseE}
            >
                <DialogTitle id="alert-dialog-title">
                    {"Nuevo Tipo de Evento"}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 1 }} display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                        {/* <CategoriaForm categoria={categoria} onResponse={handleResponse} /> */}
                        <TipoEventoForm tipo={tipoEvent} onResponse={handleResponse2}/>
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog
                open={openT}
                onClose={handleCloseT}
            >
                <DialogTitle id="alert-dialog-title">
                    {"Nueva Temática"}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ mt: 1 }} display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                       <TematicaForm tematica={tematica} onResponse={handleResponse3} />
                    </Box>
                </DialogContent>
            </Dialog>
        </Container>
    )
}